import { createFileRoute } from '@tanstack/react-router'

import { MerchantOutliersScreen } from './-components/merchant-outliers-screen.tsx'

export const Route = createFileRoute('/risk/merchant-outliers')({
  component: MerchantOutliersScreen
})
